import {
  startOfDay,
  subDays,
  addDays,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfQuarter,
  addQuarters,
  startOfYear,
  endOfYear,
} from 'date-fns'

export const calculateRangePreset = (presetName, today, serviceDate) => {
  let start
  let end

  const normalizedToday = startOfDay(today)

  switch (presetName) {
    case 'today':
      start = normalizedToday
      end = normalizedToday
      break
    case 'thisWeek':
      start = startOfDay(
        normalizedToday.getDay() === 0 ? subDays(normalizedToday, 6) : subDays(normalizedToday, normalizedToday.getDay() - 1)
      )
      end = startOfDay(normalizedToday.getDay() === 0 ? normalizedToday : addDays(normalizedToday, 7 - normalizedToday.getDay()))
      break
    case 'lastWeek':
      start = startOfDay(
        normalizedToday.getDay() === 0 ? subDays(normalizedToday, 13) : subDays(normalizedToday, normalizedToday.getDay() + 6)
      )
      end = startOfDay(normalizedToday.getDay() === 0 ? subDays(normalizedToday, 7) : subDays(normalizedToday, normalizedToday.getDay()))
      break
    case 'last7Days':
      start = startOfDay(subDays(normalizedToday, 6))
      end = normalizedToday
      break
    case 'lastUpcomingWeek':
      start = startOfDay(subDays(normalizedToday, 7))
      end = startOfDay(addDays(normalizedToday, 7))
      break
    case 'currentMonth':
      start = startOfMonth(normalizedToday)
      end = startOfDay(endOfMonth(normalizedToday))
      break
    case 'nextMonth':
      start = startOfMonth(addMonths(normalizedToday, 1))
      end = startOfDay(endOfMonth(addMonths(normalizedToday, 1)))
      break
    case 'nextQuarter':
      start = startOfQuarter(addQuarters(normalizedToday, 1))
      end = startOfDay(endOfMonth(addMonths(start, 2)))
      break
    case 'next6Months':
      start = normalizedToday
      end = startOfDay(endOfMonth(addMonths(normalizedToday, 5)))
      break
    case 'thisYear':
      start = startOfYear(normalizedToday)
      end = startOfDay(endOfYear(normalizedToday))
      break
    case 'reset':
      start = null
      end = null
      break
    default:
      return null
  }

  return { start, end }
}
